import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-usrinfo',
  templateUrl: './usrinfo.component.html',
  styleUrls: ['./usrinfo.component.css']
})
export class UsrinfoComponent implements OnInit {

  @Input() myItemSession: any;
  RoleName: string;

  constructor() { }

  ngOnInit() {
    this.RoleName = this.myItemSession.RoleName || '(undefined)';
  }

}
